const BaseModel = require('./BaseModel');
const MatchAnyEntityFilter = require('./EntityFilter/MatchAnyEntityFilter');

class EntityFilter extends BaseModel {
  static basePath = null;
  static dataType = 'entity-filter';

  constructor(json={}) {
    super(json);

    this.parseChildren(['filter']);
  }

  isValid() {
    this.errors = [];

    if(this.filter.find(filter => !filter.isValid())) {
      this.errors.push(['filter', 'contains at least one invalid filter']);
    }

    return(this.errors.length == 0)
  }
}

EntityFilter.MatchAnyEntityFilter = MatchAnyEntityFilter;

BaseModel.models[EntityFilter.dataType] = EntityFilter;

module.exports = EntityFilter;
